export default function CheckBoxControl({ className, checked, onClick, iconColor }) {
  return (
    <div onClick={onClick}
         className={`inline-block relative justify-center ${className}`}>
      {
        checked &&
        <i className="absolute bottom-0 left-[-1px] iconfont icon-yes text-white mdmax:text-[13px] mdmax:left-[0px]"
           style={{ lineHeight: '13px', color: iconColor }}></i>
      }
    </div>
  );
}
